module.exports = __webpack_public_path__ + "media/reskin-images/icon--danger-d74fbd7e.svg";